const lightbox = document.querySelector('.lightbox');
const lightboxCloseButton = document.querySelector('.lightbox__close');

if (lightbox && lightboxCloseButton) {
    const lightboxContentContainer = lightbox.querySelector('.lightbox__content');
    const lightboxImageContainer = lightbox.querySelector('.lightbox__image');
    const lightboxCaptionContainer = lightbox.querySelector('.lightbox__caption');

    if (lightboxContentContainer && lightboxImageContainer && lightboxCaptionContainer) {
        [...document.querySelectorAll('[data-lightbox]')].forEach(figureElement => {
            figureElement.addEventListener('click', () => {
                lightboxImageContainer.innerHTML = figureElement.innerHTML;

                const caption = figureElement.getAttribute('data-lightbox');
                if (caption && caption != '') {
                    lightboxCaptionContainer.innerHTML = caption;
                }

                lightbox.classList.add('lightbox--open');
            });
        });

        lightboxContentContainer.addEventListener('click', e => {
            e.stopPropagation();
        });
    }

    lightbox.addEventListener('click', () => {
        lightbox.classList.remove('lightbox--open');
    });

    document.onkeydown = function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ('key' in evt) {
            isEscape = evt.key === 'Escape' || evt.key === 'Esc';
        } else {
            isEscape = evt.keyCode === 27;
        }
        if (isEscape) {
            lightbox.classList.remove('lightbox--open');
        }
    };
}
